<template>
  <div>
    <el-table :data="parentData" class="xiang-box" height="calc(100vh - 500px)">
      <el-table-column
        label="工单编号"
        align="center"
        prop="orderNo"
        width="150"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="工单名称"
        align="center"
        prop="orderName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="任务名称"
        align="center"
        prop="taskName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="任务描述"
        align="center"
        prop="taskDescription"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="服务内容"
        align="center"
        prop="serveContent"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div class="content" v-html="scope.row.serveContent"></div>
        </template>
      </el-table-column>
      <el-table-column
        label="处理结果"
        align="center"
        prop="handleResult"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="任务状态"
        align="center"
        prop="taskStatus"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.taskStatus == 'finish' ? 'info' : ''">{{
            scope.row.taskStatus | StatusFiltering
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="人员"
        align="center"
        prop="personNames"
        :show-overflow-tooltip="true"
      />
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleDetail(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>

      <!-- <el-table-column
          label="签署时间"
          align="center"
          prop="updateTime"
          width="170"
        >
        </el-table-column>
        <el-table-column
          label="签字结果"
          align="center"
          prop="taskStatus"
          width="120"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 30px; height: 30px; transform: rotate(-90deg)"
              :src="IP + scope.row.base64"
              :preview-src-list="[IP + scope.row.base64]"
              v-if="scope.row.signFlag == true"
            >
            </el-image>
          </template>
        </el-table-column> -->
    </el-table>
    <el-dialog
      :title="title + '详情'"
      :visible.sync="dialogVisible"
      width="45%"
      append-to-body
    >
      <my-timeline :events="timelineEvents" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getistByTaskId } from "@/api/work/WorkTaskList";
import MyTimeline from "@/components/Timeline";

export default {
  components: {
    MyTimeline,
  },

  props: {
    parentData: {
      type: null,
      default: [],
    },
  },
  data() {
    return {
      IP: process.env.VUE_APP_BASE_API,
      taskList: [],
      timelineEvents: [],
      dialogVisible: false,
      title: "",
    };
  },
  created() {
    console.log(this.parentData);
  },
  methods: {
    async handleDetail(row) {
      this.title = row.orderName;
      let { data } = await getistByTaskId(row.taskId);
      this.timelineEvents = data;
      this.dialogVisible = true;
    },

  },
};
</script>
<style scoped>
.content img {
  max-width: 100%;
}
</style>